export const checkString = (str: string, setStr: any) => {
  if (str === '') {
    setStr('Вы ввели пустую строку');
  } else if (str.trim() === '') {
    setStr('Строка содержит только пробелы');
  }
}
